'use client';

import * as React from 'react';
import { usePathname } from 'next/navigation';
import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes';
import { brandingPreviewThemeFromPath } from '@/lib/ui/brandingPreview';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const pathname = usePathname();
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="theme"
      forcedTheme={brandingPreviewThemeFromPath(pathname)}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
